import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

@observer
export class DeleteContentControls extends React.Component<{ store: X7PushableBlockStore }> {
  render() {
    const {store} = this.props;
    const deleteContent = store.deleteContent;
    if (deleteContent === null)
      return null;

    const isFailure = deleteContent.save?.isPending === true;

    return (
      <>
        {
          isFailure &&
          <div className="row justify-content-end" key="delete-content-controls">
            <div className="col-auto">
              <button type="button" className="btn btn-primary"
                      onClick={store.cancel}>
                Cancel
              </button>
              <button type="button" className="btn btn-danger"
                      onClick={store.completeDeleteContent}>
                Delete
              </button>
            </div>
          </div>
        }
        <PromiseMessage label="Deleting" state={deleteContent.save} align="right"/>
      </>
    );
  }
}
